<template>
  <div class="desk-frame contact-page">
    <div
      class="head_row_calander bg--white flex flex--content--center no_mobile"
    >
      <h1 class="title title--40 no-marge tx--blue2">צור קשר עם בית החולים</h1>
    </div>
    <menu-desktop class="no_mobile" />

    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <transition name="slide">
      <div class="contact h-main bg--white m-no-bg page-edit-padd">
        <div class="before-send" v-show="!formSent">
          <div class="text center let-1 mb--22">
            שלום {{ activeDoctor.name }},
            <br />
            באפשרותך לשלוח פנייה ישירה למחלקות בבית החולים בטופס מטה.
          </div>
          <ValidationObserver ref="contactForm">
            <form @submit.prevent="sendForm" autocomplete="off">
              <div class="contact-col2">
                <div class="form_input">
                  <validation-provider
                    name="sender"
                    mode="lazy"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input
                      name="sender"
                      v-model="sender"
                      type="text"
                      autocomplete="off"
                      placeholder="שם הפונה"
                    />
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="form_input">
                  <validation-provider
                    name="phone2"
                    mode="lazy"
                    :rules="{
                      required: true,
                      regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/
                    }"
                    v-slot="{ errors }"
                  >
                    <input
                      name="phone2"
                      v-model="phone"
                      type="tel"
                      autocomplete="off"
                      placeholder="טלפון לחזרה"
                    />
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="filter_select">
                <select2 name="subject" v-model="subject">
                  <option value="">סוג הפנייה</option>
                  <option
                    v-for="(subject, index) in subjects"
                    :key="index"
                    :value="subject"
                  >
                    {{ subject }}
                  </option>
                </select2>
              </div>

              <div class="form_input">
                <textarea
                  placeholder="הקלד הודעה כאן..."
                  v-model="text"
                  autocomplete="off"
                ></textarea>
              </div>

              <div class="form_submit" :class="{ bt_disable: emptyForm }">
                <input type="submit" value="שליחה" />
              </div>
            </form>
          </ValidationObserver>
          <div class="error-message" v-if="errorMessge">{{ errorMessge }}</div>
        </div>

        <div class="after-send m-center" v-show="formSent">
          <Thank />
          <div class="title tx--blue2">
            תודה, פנייתך נשלחה<br />
            בהצלחה!
          </div>
          <!-- <div class="text let-1">
            פסקת טקסט קצרה כאן משהו לומר בקצרה ליצירת קשר
          </div> -->
          <button class="bt_blue w-100" @click="formSent = false">
            שליחת פניה נוספת
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Thank from "@/assets/img/svg/thank.svg";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import { mapGetters, mapMutations, mapState } from "vuex";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import Error from "@/components/Popups/Error";

export default {
  name: "Contact",

  components: {
    Thank,
    Menu,
    DashboardHeader,
    MenuDesktop
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE"]),
    ...mapState(["activeUser", "activeDoctor"]),
    emptyForm() {
      if (this.text) {
        return false;
      }
      return true;
    }
  },
  data: function() {
    return {
      loaded: false,
      formSent: false,
      subjects: [],
      text: "",
      subject: "",
      phone: "",
      sender: "",
      errorMessge: ""
    };
  },
  methods: {
    ...mapMutations(["UPDATE_MENU_STATE"]),
    async sendForm() {
      this.errorMessge = "";
      const res = await this.$refs.contactForm.validate();
      if (!res) return;

      this.$API
        .sendForm({
          name: this.activeDoctor.name,
          user_id: this.activeUser.user_id,
          subject: this.subject,
          text: this.text,
          phone: this.phone,
          sender: this.sender
        })
        .then(res => {
          if (res.status == "ERROR") {
            this.errorMessge = res.message;
          } else {
            this.formSent = true;
            this.text = "";
            this.subject = "";
            this.phone = "";
            this.sender = "";
            this.$refs.contactForm.reset();
          }
        })
        .catch(e => {
          if (e.status == "ERROR") {
            this.errorMessge = e.message;
          }
        });
    }
  },
  mounted() {
    this.loaded = true;
    this.$API
      .getTypehead("form_subjects")
      .then(res => {
        this.subjects = res;
      })
      .catch(e => {
        this.$modal.show(Error);
      });
    if (this.MENU_ACTIVE) {
      this.UPDATE_MENU_STATE(false);
    }
  }
};
</script>
